import { render, staticRenderFns } from "./AdsList.vue?vue&type=template&id=a42a2b78&scoped=true&"
import script from "./AdsList.vue?vue&type=script&lang=js&"
export * from "./AdsList.vue?vue&type=script&lang=js&"
import style0 from "./AdsList.vue?vue&type=style&index=0&id=a42a2b78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a42a2b78",
  null
  
)

export default component.exports